var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77279 9.79581C4.66673 9.79581 4.56461 9.77672 4.46643 9.73854C4.36764 9.70096 4.28037 9.64429 4.20461 9.56854L0.409154 5.77308C0.272791 5.63672 0.208245 5.47369 0.215518 5.28399C0.223397 5.0949 0.287942 4.93217 0.409154 4.79581C0.545518 4.65945 0.708548 4.59126 0.898245 4.59126C1.08734 4.59126 1.24249 4.65945 1.3637 4.79581L4.77279 8.2049L12.6364 0.341264C12.7576 0.2049 12.9167 0.136719 13.1137 0.136719C13.3107 0.136719 13.4698 0.2049 13.591 0.341264C13.7273 0.477628 13.7955 0.640355 13.7955 0.829446C13.7955 1.01914 13.7273 1.18217 13.591 1.31854L5.34097 9.56854C5.26522 9.64429 5.17825 9.70096 5.08006 9.73854C4.98128 9.77672 4.87885 9.79581 4.77279 9.79581Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/check_white.6a62c08cb5f2239eb57e0dfa597f1057.svg";
export { ForwardRef as ReactComponent };